import QInput from './src/QInput.vue';

/* istanbul ignore next */
QInput.install = function(Vue) {
  Vue.component(QInput.name, QInput);
};

export default QInput;
